<template>
    <div>

        <div v-if="isBlank || isNotFound" class="align-center justify-center pa-5 text-center grey--text">
            <div class="wire-message">{{ isBlank ? welcomeMessage : notFoundMessage }}</div>
            <div v-if="showCanSkip" class="skip-wire-message mt-5" @click="askSkip"><u>Продолжить без привязки услуг</u>
            </div>

            <v-dialog :value="dialog" persistent no-click-animation width="80%">
                <v-card v-if="dialog">
                    <div class="pa-5">Пропустить этап привязки услуг к Вашей учетной записи? Вы всегда можете вернуться
                        к этой возможности позже.</div>
                    <v-card-actions class="flex-wrap justify-end">
                        <v-btn text class="sg-skip-cancel" color="primary" @click="dialog = false">Отмена</v-btn>
                        <v-btn text class="sg-skip-accept" color="red" @click="skipWire">Пропустить</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <template v-else>
            <v-list two-line class="py-0" color="transparent">
                <v-list-item v-for="item in optionsRange" :key="item.id" @click="$emit('select', item)">
                    <v-list-item-content class="d-block">
                        <v-list-item-title>
                            {{formatItem(item)}}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{item.city}}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
            <v-btn ref="showMoreButton" v-if="itemsLeft > 0" @click="optionsCount+=20" text color="primary" block>
                Показать еще ({{itemsLeft}})</v-btn>
        </template>
    </div>
</template>

<script>
    export default {

        props: {
            autocompList: {
                type: Object
            },
            canSkip: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        watch: {
            autocompList() {
                this.optionsCount = 20
            }
        },

        computed: {

            showCanSkip() {
                return this.canSkip === true
            },

            itemsLeft() {
                if (this.autocompList && this.autocompList.options && this.autocompList.options.length > 0) {
                    return Math.max(this.autocompList.options.length - this.optionsRange.length, 0)
                }
                return 0
            },
            optionsRange() {
                const r = [];
                if (this.autocompList && this.autocompList.options && this.autocompList.options.length > 0) {
                    for (let i = 0; i < Math.min(this.optionsCount, this.autocompList.options.length); i++) {
                        r.push(this.autocompList.options[i]);
                    }
                }
                return r;
            },
            isBlank() {
                return !this.autocompList || !this.autocompList.options
            },
            isNotFound() {
                return !this.isBlank && this.autocompList.options.length == 0
            },
        },

        data() {
            return {
                optionsCount: 20,
                welcomeMessage: 'Введите Ваш адрес для поиска услуг. Например, Барнаул Ленина 234а 56.',
                notFoundMessage: 'По Вашему запросу ничего не найдено. Уточните данные для поиска.',
                dialog: false
            }
        },
        methods: {
            skipWire() {
                this.$emit('skip')
            },
            askSkip() {
                this.dialog = true
            },
            formatItem(item, full) {
                if (item) {
                    let arr = []
                    if (full && item.city) arr.push(item.city)
                    if (item.street) arr.push(item.street)
                    if (item.building) arr.push(item.building)
                    if (item.apartment) arr.push(item.apartment)
                    return arr.join(', ')
                }
                return ''
            }
        }
    }
</script>

<style>

</style>